import TileKit from '@/legacy/TileKit';
import Pricing from './Pricing/Pricing';
import Terms from './Terms';

const PriceAndTerms = () => (
  <>
    <TileKit.Pane className="middle-frame-pane">
      <Pricing />
    </TileKit.Pane>
    <TileKit.Pane className="middle-frame-pane">
      <Terms />
    </TileKit.Pane>
  </>
);

export default PriceAndTerms;
